export const injectTimes = o => {
	// console.log(o);
	// console.log(o.readyAt, o.id);
	const dateNow = new Date().getTime();

	// const sentToDeliveriesAt =
	//   o.status === "pe" || o.status === "pi"
	//     ? new Date(o.createdAt).getTime() + o.delayMinutes * 60 * 1000
	//     : undefined;

	// sentToDeliveriesAt --> readyAt
	// timeSinceReceived --> timeSinceReady

	// console.log(o);

	let willBeReadyIn = (o.readyAt - dateNow) / 1000 / 60;
	// willBeReadyIn = parseFloat(`${willBeReadyIn}`.toString().toFixed(1));
	// console.log("willBeReadyIn bef:", willBeReadyIn);
	willBeReadyIn = willBeReadyIn >= 1 ? willBeReadyIn : willBeReadyIn > 0.5 ? 0.5 : 0; // Number(willBeReadyIn.toFixed(1));
	if (willBeReadyIn > 1) {
		willBeReadyIn = Math.floor(willBeReadyIn);
	}
	// console.log("willBeReadyIn after:", willBeReadyIn);
	let timeSinceReady = Math.floor((dateNow - o.readyAt) / 1000 / 60);
	if (timeSinceReady < 0) {
		timeSinceReady = 0;
	}
	const iWillReturn = {
		...o,
		// willBeReadyIn:
		//   o.status === "d"
		//     ? (new Date(o.createdAt).getTime() + o.delayMinutes * 60 * 1000 - dateNow) / 1000 / 60
		//     : undefined,

		willBeReadyIn,

		timeSinceReady,
		// timeSinceReceived:
		//   sentToDeliveriesAt === undefined
		//     ? undefined
		//     : Math.floor((dateNow - sentToDeliveriesAt) / 1000 / 60),
		timeSinceAssigned: !o?.assignedAt
			? undefined
			: Math.floor((dateNow - new Date(o.assignedAt).getTime()) / 1000 / 60),
	};

	// console.log("for ", o.id, " injecting: ", {
	//   willBeReadyIn,

	//   timeSinceReady: Math.floor((dateNow - o.readyAt) / 1000 / 60),
	//   // timeSinceReceived:
	//   //   sentToDeliveriesAt === undefined
	//   //     ? undefined
	//   //     : Math.floor((dateNow - sentToDeliveriesAt) / 1000 / 60),
	//   timeSinceAssigned: !o?.assignedAt
	//     ? undefined
	//     : Math.floor((dateNow - new Date(o.assignedAt).getTime()) / 1000 / 60),
	// });
	return iWillReturn;
};
